import React from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import Grid from "@mui/joy/Grid";
import CardOverflow from "@mui/joy/CardOverflow";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Alert from "@mui/joy/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import Key from "@mui/icons-material/Key";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CheckIcon from "@mui/icons-material/Check";
import FormHelperText from "@mui/joy/FormHelperText";

export default function CambiarContrasena() {
  let [contenidoAlerta, setcontenidoAlerta] = React.useState({
    color: "",
    startDecorator: "",
    contenido: "",
    estado: false,
  });
  let { id, token } = useParams();
  let [inputPassword, setInputPassword] = React.useState("password");
  let [contrasena, setContrasena] = React.useState("");
  let navigate = useNavigate();
  let url = process.env.REACT_APP_FRONTEND_URL;

  let cambiar = async () => {
    try {
      let cambiarPassword = await axios.post(
        `${url}/api/cambio-de-contrasena/${id}/${token}`,
        { contrasena: contrasena }
      );
      if (cambiarPassword.status === 200) {
        setcontenidoAlerta({
          color: "success",
          startDecorator: <CheckIcon />,
          contenido: "¡Contraseña Cambiada Correctamente!, Redirigiendo...",
          estado: true,
        });
      }
      setTimeout(() => {
        setcontenidoAlerta({ estado: false });
        navigate("/iniciar-sesion");
      }, 3000);
    } catch (err) {
      setcontenidoAlerta({
        color: "danger",
        startDecorator: <ErrorIcon />,
        contenido: "Hubo un error al Procesar tu Solicitud",
        estado: true,
      });
      setTimeout(() => {
        setcontenidoAlerta({ estado: false });
      }, 3000);
    }
  };

  let popup = () => {
    return (
      <Alert
        variant="soft"
        className="notificacion"
        color={contenidoAlerta.color}
        startDecorator={contenidoAlerta.startDecorator}
      >
        {contenidoAlerta.contenido}
      </Alert>
    );
  };

  return (
    <div>
      {contenidoAlerta.estado ? popup() : null}
      <Box
        sx={{ display: "flex", height: "100vh", justifyContent: "center" }}
        className="fondoLogin"
      >
        <Grid
          container
          spacing={2}
          sx={{ width: "100%", justifyContent: "center" }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column", // Para organizar los hijos verticalmente
              alignItems: "center", // Centra horizontalmente
              justifyContent: "center", // Centra verticalmente
              height: "100%", // Hace que el Grid ocupe todo el espacio del contenedor
            }}
          >
            <Card
              variant="plain"
              size="lg"
              sx={{ width: "80%", paddingTop: "10%", paddingBottom: "10%" }}
            >
              <CardOverflow
                sx={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  marginBottom: "1rem",
                  justifyContent: "center",
                  marginTop: "1rem",
                }}
              >
                <Typography
                  level="h3"
                  sx={{
                    marginBottom: "1rem",
                    display: "flex",
                    alignContent: "left",
                    alignItems: "left",
                  }}
                >
                  Restablecer Contraseña
                </Typography>
              </CardOverflow>

              <CardContent>
                <FormControl>
                  <FormLabel>Nueva Contraseña</FormLabel>
                  <Input
                    variant="outlined"
                    placeholder="••••••••••"
                    startDecorator={<Key />}
                    type={inputPassword}
                    endDecorator={
                      <RemoveRedEyeIcon
                        onClick={() => {
                          if (inputPassword === "password") {
                            setInputPassword("text");
                          } else if (inputPassword === "text") {
                            setInputPassword("password");
                          }
                        }}
                      />
                    }
                    onChange={(event) => {
                      setContrasena(event.target.value);
                    }}
                  ></Input>
                  <FormHelperText>
                    Tu seguridad depende de ti. Usa una contraseña fuerte con al
                    menos 12 caracteres, combinando letras, números y símbolos.
                  </FormHelperText>
                </FormControl>

                <Button
                  sx={{ marginTop: "1rem" }}
                  variant="outlined"
                  color="neutral"
                  onClick={cambiar}
                >
                  Restablecer
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          ></Grid>
        </Grid>
      </Box>
    </div>
  );
}
